import type { StockTransferListRow } from "@/modules/inventory/presentation/api/client";
import { TransferStatusBadge } from "@/modules/inventory/presentation/ui/transfers/TransferStatusBadge";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { formatDateTimeLocal } from "@/shared/lib/date-time";

export function TransfersTable({
  data,
  onOpen,
}: {
  data: StockTransferListRow[];
  onOpen: (row: StockTransferListRow) => void;
}) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>ເລກທີ</TableHead>
          <TableHead>ສະຖານະ</TableHead>
          <TableHead>ສາຂາຂໍ</TableHead>
          <TableHead>Hub</TableHead>
          <TableHead className="text-right">ບັນທັດ</TableHead>
          <TableHead>ສົ່ງຄຳຂໍ</TableHead>
          <TableHead />
        </TableRow>
      </TableHeader>
      <TableBody>
        {data.length === 0 ? (
          <TableRow>
            <TableCell colSpan={7} className="text-center text-muted-foreground">
              ບໍ່ມີຄຳຂໍ
            </TableCell>
          </TableRow>
        ) : (
          data.map((row) => (
            <TableRow key={row.id}>
              <TableCell className="font-mono text-sm">{row.requestNo}</TableCell>
              <TableCell>
                <TransferStatusBadge status={row.status} />
              </TableCell>
              <TableCell>
                {row.fromBranchCode} — {row.fromBranchName}
              </TableCell>
              <TableCell>{row.toBranchCode}</TableCell>
              <TableCell className="text-right">{row.lineCount}</TableCell>
              <TableCell className="text-muted-foreground text-sm">
                {row.submittedAt
                  ? formatDateTimeLocal(new Date(row.submittedAt))
                  : "—"}
              </TableCell>
              <TableCell className="text-right">
                <Button
                  type="button"
                  variant="outline"
                  size="sm"
                  onClick={() => onOpen(row)}
                >
                  ເປີດ
                </Button>
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
}
